module.exports = __webpack_public_path__ + "static/media/CardStatement.bc19490c.svg";